export default "__VITE_ASSET__306f13dc__"